<section
  class="main-wrap inner-views dashboard-wrap"
  [ngClass]="{ 'menu-open in': !toggleClass }"
>
  <nav class="navbar navbar-expand-lg" id="desk-top-nav">
    <app-user-menu></app-user-menu>
    <div class="button-box">
      <button
        class="btn dropdown-toggle"
        type="button"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span class="sr-only">Toggle Dropdown</span>
        <img
          height="45"
          src="assets/images/icons/hamburger-menu-50x50.svg"
          width="45"
          alt="Menu Icon"
        />
      </button>
      <div class="dropdown-menu">
        <app-menu></app-menu>
        <app-menu-alt></app-menu-alt>
      </div>
    </div>
  </nav>
  <div class="container-wrap">
    <div class="heading-container sidebar-container" id="menu">
      <div class="row">
        <div class="col">
          <app-logo></app-logo>
          <div class="button-box">
            <button
              class="btn btn-sm-menu"
              type="button"
              (click)="toggleClass = !toggleClass"
            >
              <img
                height="45"
                src="assets/images/icons/hamburger-menu-50x50.svg"
                width="45"
                alt="Menu Icon"
              />
            </button>
          </div>
          <app-header></app-header>
        </div>
      </div>
    </div>
    <div class="content-container profile-container">
      <div class="row">
        <div class="col-md-12 dash-title">
          <h1>
            <span class="app-user"
              >{{ employee?.firstName }} {{ employee?.lastName }}</span
            >
            Profile
          </h1>
        </div>
        <div class="clearfix"></div>
        <div class="col-md-6 profile-box">
          <h2>My Profile Picture</h2>
          <div class="profile-img-wrap">
            <app-secure-image
              [filename]="employee?.unscaledImageName"
            ></app-secure-image>
            <!-- <img class="rounded-circle" src="assets/images/users/user-name.jpg" alt="User Profile Picture"/> -->
            <a class="profile-edit" [routerLink]="['upload-photo']"
              ><img
                height="28"
                src="assets/images/icons/edit-61x54.svg"
                width="25"
                alt="Edit Icon"
            /></a>
          </div>
        </div>
        <div class="col-md-6 profile-data">
          <div class="accordion" id="accordion-profile">
            <div class="card">
              <div class="card-header" id="profile-login">
                <h2 class="mb-0">
                  <button
                    aria-controls="profileLogin"
                    aria-expanded="false"
                    class="btn btn-link btn-block text-left collapsed"
                    data-target="#profileLogin"
                    data-toggle="collapse"
                    type="button"
                  >
                    Security
                  </button>
                </h2>
              </div>
              <div
                aria-labelledby="profile-login"
                class="collapse"
                data-parent="#accordion-profile"
                id="profileLogin"
              >
                <div class="card-body">
                  <div class="form-wrap inner-forms">
                    <form [formGroup]="loginForm">
                      <div class="formField userinput">
                        <label for="username">Username</label>
                        <input
                          id="username"
                          formControlName="username"
                          placeholder="Enter Username"
                          type="text"
                        />
                      </div>
                      <div class="formField passInput">
                        <label for="newPassword">Password</label>
                        <input
                          id="newPassword"
                          class="form-control"
                          formControlName="newPassword"
                          placeholder="Enter a Password"
                          type="password"
                          [ngClass]="{
                            'is-invalid':
                              loginSubmitted && lfc.newPassword.errors,
                          }"
                        />
                        @if (loginSubmitted && lfc.newPassword.errors) {
                          <div class="invalid-feedback">
                            @if (lfc.newPassword.errors.required) {
                              <div>Password is required.</div>
                            }
                            @if (lfc.newPassword.errors.noWhiteSpace) {
                              <div>Password cannot be an empty string.</div>
                            }
                            @if (
                              lfc.newPassword.errors.pattern ||
                              lfc.newPassword.errors.minlength
                            ) {
                              <div>
                                Password must meet the following requirements:
                                <ul>
                                  <li>
                                    Password must be at least
                                    {{ passwordMinLength }} characters long.
                                  </li>
                                  <li>
                                    Contain at least one capital case letter.
                                  </li>
                                  <li>
                                    Contain at least one lower case letter.
                                  </li>
                                  <li>Contain at least one number.</li>
                                </ul>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div class="formField passInput">
                        <label for="confirmPassword">Confirm Password</label>
                        <input
                          id="confirmPassword"
                          class="form-control"
                          formControlName="confirmPassword"
                          placeholder="Re-enter your Password"
                          type="password"
                          [ngClass]="{
                            'is-invalid':
                              loginSubmitted && lfc.confirmPassword.errors,
                          }"
                        />
                        @if (loginSubmitted && lfc.confirmPassword.errors) {
                          <div class="invalid-feedback">
                            @if (lfc.confirmPassword.errors.required) {
                              <div>Confrim Password is required.</div>
                            }
                            @if (lfc.confirmPassword.errors.mustMatch) {
                              <div>Passwords do not match.</div>
                            }
                          </div>
                        }
                      </div>
                      <div class="formField submitInput">
                        <input
                          class="form-submit gray-btn"
                          type="button"
                          value="Update"
                          (click)="onLoginFormSubmit()"
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header" id="profile-gen">
                <h2 class="mb-0">
                  <button
                    aria-controls="profileGen"
                    aria-expanded="false"
                    class="btn btn-link btn-block text-left collapsed"
                    data-target="#profileGen"
                    data-toggle="collapse"
                    type="button"
                  >
                    General Info
                  </button>
                </h2>
              </div>
              <div
                aria-labelledby="profile-gen"
                class="collapse"
                data-parent="#accordion-profile"
                id="profileGen"
              >
                <div class="card-body">
                  <div class="form-wrap inner-forms">
                    <form [formGroup]="generalForm">
                      <div class="formField dateInput">
                        <label for="dateOfBirth">Birthdate</label>
                        <input
                          id="dateOfBirth"
                          formControlName="dateOfBirth"
                          type="date"
                        />
                      </div>
                      <div class="formField genderInput">
                        <label for="gender">Gender</label>
                        <select
                          size="1"
                          name="cf_drop_down"
                          id="gender"
                          formControlName="gender"
                        >
                          <option value="Male">Male</option>
                          <option value="Female">Female</option>
                          <option value="Transgender Female">
                            Transgender Female
                          </option>
                          <option value="Transgender Male">
                            Transgender Male
                          </option>
                          <option value="Gender Variant/Non-conforming">
                            Gender Variant/Non-conforming
                          </option>
                          <option value="Not Listed">Not Listed</option>
                          <option value="Prefer Not to Answer">
                            Prefer Not to Answer
                          </option>
                        </select>
                      </div>
                      <div class="formField submitInput">
                        <input
                          class="form-submit gray-btn"
                          type="button"
                          value="Update"
                          (click)="onUpdateGeneralInfo()"
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header" id="contact-info">
                <h2 class="mb-0">
                  <button
                    aria-controls="contactInfo"
                    aria-expanded="false"
                    class="btn btn-link btn-block text-left collapsed"
                    data-target="#contactInfo"
                    data-toggle="collapse"
                    type="button"
                  >
                    Contact Info
                  </button>
                </h2>
              </div>
              <div
                aria-labelledby="contact-info"
                class="collapse"
                data-parent="#accordion-profile"
                id="contactInfo"
              >
                <div class="card-body">
                  <div class="form-wrap inner-forms">
                    <form [formGroup]="contactInfoForm">
                      <div class="formField emailinput">
                        <label for="email">Email Address</label>
                        <span class="warning-text"
                          >(Changing this email will change the email used for
                          login.)</span
                        >
                        <input
                          id="email"
                          class="form-control"
                          formControlName="emailAddress"
                          placeholder=""
                          type="email"
                          [ngClass]="{
                            'is-invalid':
                              contactSubmitted && cfc.emailAddress.errors,
                          }"
                        />
                        @if (contactSubmitted && cfc.emailAddress.errors) {
                          <div
                            class="invalid-feedback"
                            [ngClass]="{
                              'd-block':
                                contactSubmitted && cfc.emailAddress.errors,
                            }"
                          >
                            Invalid Email Address
                          </div>
                        }
                      </div>
                      <div class="formField phoneInput">
                        <label for="homePhone">Home Phone</label>
                        <input
                          id="homePhone"
                          class="form-control"
                          formControlName="homePhone"
                          placeholder=""
                          type="text"
                          mask="(000) 000-0000"
                          [ngClass]="{
                            'is-invalid':
                              contactSubmitted && cfc.homePhone.errors,
                          }"
                        />
                        @if (contactSubmitted && cfc.homePhone.errors) {
                          <div
                            class="invalid-feedback"
                            [ngClass]="{
                              'd-block':
                                contactSubmitted && cfc.homePhone.errors,
                            }"
                          >
                            Invalid Phone Number
                          </div>
                        }
                      </div>
                      <div class="formField mobilePhoneInput">
                        <label for="mobilePhone">Mobile Phone</label>
                        <input
                          id="mobilePhone"
                          class="form-control"
                          formControlName="mobilePhone"
                          placeholder=""
                          type="text"
                          mask="(000) 000-0000"
                          [ngClass]="{
                            'is-invalid':
                              contactSubmitted && cfc.mobilePhone.errors,
                          }"
                          (keyup)="onKeyUp($event)"
                        />
                        @if (contactSubmitted && cfc.mobilePhone.errors) {
                          <div
                            class="invalid-feedback"
                            [ngClass]="{
                              'd-block':
                                contactSubmitted && cfc.mobilePhone.errors,
                            }"
                          >
                            Invalid Phone Number
                          </div>
                        }
                      </div>
                      @if (isShowOptIn) {
                        <div class="formField noBg formCheck">
                          <input
                            class="form-check-input form-control"
                            formControlName="isOptedIn"
                            id="gridCheck"
                            type="checkbox"
                          />
                          <label class="form-check-label" for="gridCheck">
                            Yes, I would like to receive periodic text messages
                            regarding orders, benefits and information regarding
                            my account with Eyelation. I understand I may
                            opt-out at anytime and that data and message rates
                            may apply.
                          </label>
                        </div>
                      }
                      @if (
                        contactSubmitted &&
                        contactInfoForm.errors?.requiredOneOf
                      ) {
                        <div
                          class="invalid-feedback"
                          [ngClass]="{
                            'd-block':
                              contactSubmitted &&
                              contactInfoForm.errors?.requiredOneOf,
                          }"
                        >
                          At least one Email Address, Home Phone, or Mobile
                          Phone is required.
                        </div>
                      }
                      <div class="formField submitInput">
                        <input
                          class="form-submit gray-btn"
                          type="button"
                          value="Update"
                          (click)="onContactFormSubmit()"
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="card">
              <div class="card-header" id="home-address">
                <h2 class="mb-0">
                  <button
                    aria-controls="homeAddress"
                    aria-expanded="false"
                    class="btn btn-link btn-block text-left collapsed"
                    data-target="#homeAddress"
                    data-toggle="collapse"
                    type="button"
                  >
                    Home Address
                  </button>
                </h2>
              </div>
              <div
                aria-labelledby="home-address"
                class="collapse"
                data-parent="#accordion-profile"
                id="homeAddress"
              >
                <div class="card-body">
                  <div class="form-wrap inner-forms">
                    <form>
                      <app-address-form
                        #addressForm
                        [address]="employee?.address"
                        [isCompact]="true"
                      >
                      </app-address-form>
                      <div class="formField submitInput">
                        <input
                          class="form-submit gray-btn"
                          type="button"
                          value="Update"
                          (click)="onAddressFormSubmit()"
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header" id="employer-info">
                <h2 class="mb-0">
                  <button
                    aria-controls="employerInfo"
                    aria-expanded="false"
                    class="btn btn-link btn-block text-left collapsed"
                    data-target="#employerInfo"
                    data-toggle="collapse"
                    type="button"
                  >
                    Employer Info
                  </button>
                </h2>
              </div>
              <div
                aria-labelledby="employer-info"
                class="collapse"
                data-parent="#accordion-profile"
                id="employerInfo"
              >
                <div class="card-body">
                  @if (employee) {
                    <div class="form-wrap inner-forms">
                      <div class="formField">
                        <label for="company">Company</label>
                        <input
                          id="company"
                          readonly="true"
                          disabled="true"
                          type="text"
                          [(ngModel)]="employee.companyName"
                        />
                      </div>
                      <div class="formField">
                        <label for="location">Location</label>
                        <input
                          id="location"
                          readonly="true"
                          disabled="true"
                          type="text"
                          [(ngModel)]="employee.locationDescription"
                        />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header" id="payment-info">
                <h2 class="mb-0">
                  <button
                    aria-controls="paymentInfo"
                    aria-expanded="false"
                    class="btn btn-link btn-block text-left collapsed"
                    data-target="#paymentInfo"
                    data-toggle="collapse"
                    type="button"
                  >
                    Payment Info
                  </button>
                </h2>
              </div>
              <div
                aria-labelledby="payment-info"
                class="collapse"
                data-parent="#accordion-profile"
                id="paymentInfo"
              >
                <div class="card-body">
                  <div class="form-wrap inner-forms">
                    <!-- <form action="#"> -->
                    <div class="formField userInput">
                      <label for="defaultCreditCard">Default Credit Card</label>
                      <input
                        id="defaultCreditCard"
                        readonly="true"
                        disabled="true"
                        type="text"
                        placeholder="No credit card added yet..."
                        [(ngModel)]="censoredCardData"
                      />
                    </div>
                    <div class="clearfix"></div>
                    <!-- <div class="formField submitInput"> -->
                    <!-- <input class="form-submit gray-btn" type="button" value="Update"> -->
                    <!-- </div> -->
                    <!-- </form> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
